<template>
  <el-drawer
    :append-to-body="true"
    :direction="'ltr'"
    :size="'75%'"
    :visible.sync="unfold"
    :with-header="false"
  >
    <!--        <template #header="{ close, titleId, titleClass }">-->
    <!--          <h4 :id="titleId" :class="titleClass">This is a custom header!</h4>-->
    <!--          <el-button type="danger" @click="close">-->
    <!--            <el-icon class="el-icon&#45;&#45;left">A</el-icon>-->
    <!--            Close-->
    <!--          </el-button>-->
    <!--        </template>-->
    <div style="background-color: #003333; height: 100%">
      <el-row style="border-bottom: 1px solid #cccccc;">
        <el-col :span="12" class="left-centered">
          <img
            alt="UNIFI Property"
            src="../../assets/unifi-logo-new-with-text-white.svg"
            style="width: 150px; height: 41px"
            @click="goToHome"
          />
        </el-col>
        <el-col :span="12" class="right-centered">
          <img alt="Close" src="../../assets/x.png" @click="unfoldMenu"/>
        </el-col>
      </el-row>
      <el-row>
        <li style="background-color: #ffffff;">
          <!--<ul class="main-menu-item-style menu-item-font">Search</ul>-->
<!--          <template v-if="isSignedIn">-->
<!--            <ul-->
<!--              class="main-menu-item-style menu-item-font"-->
<!--              @click="goToMyFavourites"-->
<!--            >-->
<!--              My Favourites-->
<!--            </ul>-->
<!--            <ul-->
<!--              class="main-menu-item-style menu-item-font"-->
<!--              @click="goToMyAccount"-->
<!--            >-->
<!--              My Account-->
<!--            </ul>-->
<!--          </template>-->
<!--          <template v-else>-->
            <ul
              class="main-menu-item-style menu-item-font"
              @click="redirectToUConnect"
            >
              Login
            </ul>
<!--            <ul-->
<!--              class="main-menu-item-style menu-item-font"-->
<!--              @click="goToContactUs"-->
<!--            >-->
<!--              Contact-->
<!--            </ul>-->
<!--          </template>-->
<!--                    <ul class="main-menu-item-style menu-item-font"-->
<!--                        @click="goToBlog"-->
<!--                    >-->
<!--                      Blog</ul>-->
        </li>
      </el-row>
      <el-row>
        <li style="background-color: #ffffff">
<!--          <ul-->
<!--            class="sub-menu-item-style sub-item-font"-->
<!--            style="padding-top: 26px"-->
<!--            @click="changePropertyType('buy')"-->
<!--          >-->
<!--            Buy-->
<!--          </ul>-->
          <ul
            class="sub-menu-item-style sub-item-font"
            style="padding-top: 26px"
            @click="goToBlog"
          >
            Blog
          </ul>
          <ul
            class="sub-menu-item-style sub-item-font"
            style="padding-top: 26px"
            @click="goToAgent"
          >
            Developers & Agents
          </ul>
          <ul
            class="sub-menu-item-style sub-item-font"
            style="padding-top: 26px ; padding-bottom: 26px"
            @click="goToPricing"
          >
            Channel Partners
          </ul>
<!--          <ul-->
<!--            class="sub-menu-item-style sub-item-font"-->
<!--            style="padding-top: 26px"-->
<!--            @click="goToHowItWorks"-->
<!--          >-->
<!--            How it works-->
<!--          </ul>-->
<!--          <ul-->
<!--            class="sub-menu-item-style sub-item-font"-->
<!--            style="padding-top: 26px"-->
<!--            @click="goToAboutUs"-->
<!--          >-->
<!--            About us-->
<!--          </ul>-->
<!--          <ul-->
<!--            class="sub-menu-item-style sub-item-font"-->
<!--            style="padding-top: 26px ; padding-bottom: 26px"-->
<!--            @click="goToContactUs"-->
<!--          >-->
<!--            Contact us-->
<!--          </ul>-->
<!--          <ul v-if="isSignedIn"-->
<!--              class="sub-menu-item-style sub-item-font"-->
<!--              style="padding-bottom: 26px"-->
<!--              @click="goToLogout"-->
<!--          >-->
<!--            Logout-->
<!--          </ul>-->
          <!--          <ul class="sub-menu-item-style sub-item-font" style="padding-top: 26px">FAQ</ul>-->
          <!--          <ul class="sub-menu-item-style light-dark-text" style="padding-top: 26px; padding-bottom: 40px">Light Dark</ul>-->
        </li>
      </el-row>
      <el-row
        style="background-color: #003333; height: 100%; padding-top: 90px"
      >
        <el-col :sm="6" :span="6" :xs="6" class="centered-social-icon">
          <a href="https://www.facebook.com/unifiproperty" target="_blank">
            <img alt="Facebook" src="../../assets/facebook48x48.png"/>
          </a>
        </el-col>
        <el-col :sm="6" :span="6" :xs="6" class="centered-social-icon">
          <a href="https://www.instagram.com/unifiproperty/" target="_blank">
            <img alt="Instagram" src="../../assets/instagram48x48.png"/>
          </a>
        </el-col>
        <!--        <el-col :span="8" :xs="8" :sm="8" class="centered-social-icon">-->
        <!--          <img alt="X" src="../../assets/x48x48.png"/>-->
        <!--        </el-col>-->
      </el-row>
      <el-row></el-row>
      <request-to-join-u-connect-corporate-dialog v-if="requestToJoinDialogVisible" :request-to-join-dialog-visible="requestToJoinDialogVisible" @onClose="requestToJoinDialogVisible = false"/>
    </div>
  </el-drawer>
</template>
<script>
import {mapActions} from "vuex";
import { redirectToUConnect } from "../../helpers/routerHelper";
import RequestToJoinUConnectCorporateDialog from "../common/requestToJoinUConnectCorporateDialog.vue";
export default {
  name: "drawer-aside",
  components: {RequestToJoinUConnectCorporateDialog},
  data() {
    return {
      requestToJoinDialogVisible: false,
      unfoldValue: false,
      isSignedIn: false,
      searchFiltersForm: {
        sort: "time",
        saleType: "1",
        propertyTypeList: ["All"],
        minPrice: "Any",
        maxPrice: "Any",
        minRentalEstimate: "Any",
        maxRentalEstimate: "Any",
        minLandSize: "Any",
        maxLandSize: "Any",
        minBuildSize: "Any",
        maxBuildSize: "Any",
        minBedrooms: "Any",
        maxBedrooms: "Any",
        bathrooms: "Any",
        carSpaces: "Any",
        searchSuburb: ""
      },
      selectedPropertyType: "buy",
    };
  },
  props: {
    unfold: Boolean
  },
  created() {
    this.getUserDtl({callback: this.userCallback});
  },
  methods: {
    ...mapActions("account", ["getUserDtl"]),
    ...mapActions("login", ["signOut"]),
    redirectToUConnect,
    unfoldMenu() {
      console.log("component called unfoldMenu");
      this.$emit("unfoldMethod");
    },
    goToMyAccount() {
      if (this.$route.path !== "/profile") {
        this.$router.push("/profile");
      } else {
        this.$emit("unfoldMethod");
      }
    },
    goToMyFavourites() {
      if (this.$route.path !== "/profile") {
        this.$router.push("/profile");
      } else {
        this.$emit("unfoldMethod");
      }
    },
    goToHome() {
      if (this.$route.path !== "/") {
        this.$router.push("/");
      } else {
        this.$emit("unfoldMethod");
      }
    },
    goToContactUs() {
        this.requestToJoinDialogVisible = true;
    },
    goToAboutUs() {
      if (this.$route.path !== "/about") {
        this.$router.push("/about");
      } else {
        this.$emit("unfoldMethod");
      }
    },
    goToHowItWorks() {
      if (this.$route.path !== "/how-it-works") {
        this.$router.push("/how-it-works");
      } else {
        this.$emit("unfoldMethod");
      }
    },
    goToAgent() {
      if (this.$route.path !== "/agents") {
        this.$router.push("/agents");
      } else {
        this.$emit("unfoldMethod");
      }
    },
    goToPricing() {
      if (this.$route.path !== "/pricing") {
        this.$router.push("/pricing");
      } else {
        this.$emit("unfoldMethod");
      }
    },
    // goToLogin() {
    //   if (this.$route.path !== "/newlogin") {
    //     this.$router.push("/newlogin");
    //   } else {
    //     this.$emit("unfoldMethod");
    //   }
    // },
    // goToRegister() {
    //   if (this.$route.path !== "/pricing") {
    //     this.$router.push("/pricing");
    //   } else {
    //     this.$emit("unfoldMethod");
    //   }
    // },
    contactUs() {

    },
    goToBlog() {
      if (this.$route.path !== "/blog") {
        this.$router.push("/blog");
      } else {
        this.$emit("unfoldMethod");
      }
    },
    goToLogout() {
      this.signOut({callback: this.logoutCallback})

    },
    userCallback(res) {
      var that = this;
      if (res.data.code == 0) {
        that.user = res.data.data;
        if (that.user != null) {
          this.isSignedIn = true;
          console.log(that.user);
        }
      } else if (res.data.code == 90000 || res.data.code == 90002) {
        //localStorage.clear()
        //that.$router.push('/login')
      } else if (res.data.code == 8902 || res.data.code == 8901) {
        // that.$box.alert('', res.data.message ,'error')
        //localStorage.clear()
        //that.$router.push('/login')
      }
    },

    // logoutCallback(res) {
    //   if (res.data.code == 0) {
    //     localStorage.clear();
    //     if (this.$route.path !== "/newlogin") {
    //       this.isSignedIn = false;
    //       this.$router.push("/newlogin");
    //     } else {
    //       this.$emit("unfoldMethod");
    //     }
    //   }
    // },
    changePropertyType(propertyType) {
      this.selectedPropertyType = propertyType;
      this.goToQuickSearch();
    },
    goToQuickSearch() {
      //get for SA only for now, and fix up post go live

      let options = sessionStorage.searchFiltersForm
        ? JSON.parse(sessionStorage.searchFiltersForm)
        : this.searchFiltersForm;

      console.log("this.searchType: ", this.searchType);

      // this.searchFiltersForm.searchType = this.searchType
      if (this.searchFiltersForm.searchSuburb) {
        this.searchFiltersForm.searchSuburb = this.searchFiltersForm.searchSuburb.replace(
          " SA, Australia",
          ""
        );
      }
      //set search Property Type
      if (this.selectedPropertyType === 'sold') {
        options.searchType = "sold";
      } else {
        options.searchType = "buy";
      }

      this.searchFiltersForm = options;

      sessionStorage.setItem("isSearch", "1");
      sessionStorage.setItem(
        "searchFiltersForm",
        JSON.stringify(this.searchFiltersForm)
      );
      if (this.$route.path !== "/property/search/results") {
        this.$router.push("/property/search/results");
      } else {
        this.$router.go();
      }
    },
  }
};
</script>
<style scoped>
.main-menu-item-style {
  padding: 30px 40px;
  background-color: #ffffff;
  border-bottom: 1px solid #cccccc;
}

.menu-item-font {
  color: #003333;
  font-feature-settings: "clig" off, "liga" off;
  font-family: DINosaur-a;
  font-size: 28px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}

.sub-menu-item-style {
  padding: 0 40px;
  background: #ffffff;
}

.sub-item-font {
  color: #003333;
  font-feature-settings: "clig" off, "liga" off;
  font-family: DINosaur-a;
  font-size: 20px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}

.centered-social-icon {
  display: flex;
  justify-content: center;
  align-items: center;
}

.left-centered {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  padding: 20px 0 20px 40px;
}

.right-centered {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding: 20px 16px 20px 0;
}

/* Extra small devices (phones, 600px and down) */
@media only screen and (max-width: 600px) {
  .menu-item-font {
    font-size: 22px;
  }

  .sub-item-font {

    font-size: 16px;
  }

}

/* Small devices (portrait tablets and large phones, 600px and up) */
@media only screen and (min-width: 600px) {

}

/* Medium devices (landscape tablets, 768px and up) */
@media only screen and (min-width: 768px) {

}

</style>



// WEBPACK FOOTER //
// src/components/package/DrawerAside.vue